import { CommonModule } from "@angular/common";
import { NgModule } from '@angular/core';
import { NumberFormatPipe } from './number-format.pipe';
import { TextLimitPipe } from './text-limit.pipe';
import { OrderBy } from './order-pipe';
import { SafePipe } from "./safe.pipe";
import { IsDropdownPipe } from './is-dropdown.pipe';
import { FilterPipe } from "./filter.pipe";

@NgModule({
	declarations: [
		NumberFormatPipe,
		TextLimitPipe,
		OrderBy,
		SafePipe,
		IsDropdownPipe,
		FilterPipe
	],
	exports: [
		NumberFormatPipe,
		TextLimitPipe,
		OrderBy,
		SafePipe,
		IsDropdownPipe,
		FilterPipe
	],
	imports: [CommonModule]
})

export class SharedModule {
}